import 'reflect-metadata';
import { FrontendFeature, FrontendFeaturesModule } from '../feature';
import { Feature } from '../interfaces/feature';

@FrontendFeaturesModule('ConsultantDevProgram')
export class ConsultantDevProgramFeatures {
  @FrontendFeature({
    summary: 'Default consultant development program page'
  })
  static readonly Default: Feature = 'learning-and-dev/consultant-dev-program';

  @FrontendFeature({
    summary: 'About consultant development program page'
  })
  static readonly About: Feature = 'learning-and-dev/consultant-dev-program/about';

  @FrontendFeature({
    summary: 'About consultant development program join'
  })
  static readonly Join: Feature = 'learning-and-dev/consultant-dev-program/join';
}
